module.exports = __webpack_public_path__ + "static/media/speedometer_high_throughput.f0798022.svg";